module.exports = __webpack_public_path__ + "img/product-preview-76.9aafbe4.png";